import classnames from "classnames";
import * as React from "react";

export interface Props {
  className?: string;
  label?: string;
  icon?: string;
  url: string;
}

const DownloadLink = (props: Props) => (
  <a className={classnames("download_link", props.className)} download target="_blank" href={props.url}>
    {!!props.icon && <i className={props.icon} />}
    {props.label}
  </a>
);
export default DownloadLink;
